module.exports = __webpack_public_path__ + "img/figure-2.a230ce9d.png";